import * as yup from 'yup';

import { useTranslations } from '../../../../../contexts/LocalizationContext';

export const useNewsNewFormValidationSchema = (): yup.AnyObjectSchema => {
  const translations = useTranslations();

  return yup.object().shape({
    title: yup.string().required(translations('validation_required')).max(255, translations('validation_too_long')),
    subtitle: yup.string().required(translations('validation_required')).max(255, translations('validation_too_long')),
    content: yup.string().required(translations('validation_required')),
  });
};
